module.exports = __webpack_public_path__ + "static/media/first_card.94ff2fc7.svg";